// src/components/lists/Items/OrderItem.js
import React , {useState} from "react";
import { List, Button, Card, Grid, GridColumn,Icon,Popup,Table } from "semantic-ui-react";
import dateFormater from "../../../utils/dateFormater";

const OrderItem = ({ 
  order, 
  exams,
  isOrderSpecial,
  showPatientOrderResults,
  showPatientOrderResultsOne,
  selectedPatientID,
  selectedPatient,
  handleOrderClick
}) => {

  const [showExams, setShowExams] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null)
  const [hasLoaded, setHasLoaded] = useState(false);

  const toggleExams = () => {
    setShowExams(!showExams);
  };

  const handleMouseEnter = (examId) => {
    setHoveredRow(examId); // Cuando el mouse entra en la fila, la fila se resalta
  };

  const handleMouseLeave = () => {
    setHoveredRow(null); // Cuando el mouse sale de la fila, se quita el resalto
  };

  /*if (!hasLoaded) {
    handleOrderClick(order.orderNumber);
    setHasLoaded(true);
  }*/

  if (hasLoaded && exams && exams.length > 0 && !showExams) {
    setShowExams(true);
  }

  const getExamColor = (codigo = '') => {
    if (codigo.startsWith("M01") || codigo.startsWith("M02") || codigo.startsWith("M04") || codigo.startsWith("M05") || codigo.startsWith("M06") ) 
      return "#c2185b"; // rosa fuerte
    if (codigo.startsWith("M03")) 
      return "#6a1b9a"; // morado
    return "#0277bd"; // azul oscuro
  };

  return (
    <Table.Row
        style={{
          cursor:"pointer",
          padding: "2px", // Reducir el espacio dentro de cada celda
          backgroundColor:"#f4f4f4", // Resaltar la fila seleccionada
          cursor: "pointer", // Hacer la fila clickeable
          transition: "background-color 0.3s", // Transición suave del hover
          borderBotton: '1px solid #ccc',
          backgroundColor: hoveredRow === `${exams?.codigo_examen || 'no-exam'}+${exams?.orderNumber || order.orderNumber}` 
            ? "#e0e0e0" 
            : "",
          fontSize:"11px"
        }}
        onClick={() => 
          
          showPatientOrderResultsOne({
            patient_id: selectedPatientID,
            orderNumber: order.orderNumber,
            fullname: selectedPatient,
            exam_id: exams?.codigo_examen || null,
            isOrderSpecial: isOrderSpecial
          })
        }
        onMouseEnter={() => setHoveredRow(`${exams?.codigo_examen}+${exams?.orderNumber}`)}
        onMouseLeave={handleMouseLeave}
      >
      <Table.Cell width={2}>{order.orderHis}</Table.Cell>
      <Table.Cell width={1}>{order.orderNumber}</Table.Cell>
      <Table.Cell width={11} style={{ color:getExamColor(exams?.codigo_seccion || "")}}>{exams?.nombre_examen || "VER EXAMEN"}</Table.Cell>
      <Table.Cell width={2}>{dateFormater(order.date)}</Table.Cell>
    </Table.Row>
  );
};

export default OrderItem;
